// components/modals/LinkModal.tsx
import styled from "styled-components";
import { useState, FormEvent } from "react";
import { flexCenterCenter } from "../../style/mixins";
import Btn from "../common/Btn";
import Input from "../common/Input";

interface LinkModalProps {
  isOpen: boolean;                 // 모달 열림 여부
  onClose: () => void;            // 모달 닫기 함수
  onConfirm: (url: string) => void; // 링크 URL을 부모로 넘기는 함수
}

export default function LinkModal({ isOpen, onClose, onConfirm }: LinkModalProps) {
  const [linkText, setLinkText] = useState("");

  // submit 시 부모에게 linkText 전달 후 리셋
  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    onConfirm(linkText.trim());
    setLinkText("");
  };

  // 모달이 닫힐 때 상태 리셋
  const handleClose = () => {
    setLinkText("");
    onClose();
  };

  // 모달이 닫혀 있으면 렌더링하지 않음
  if (!isOpen) return null;

  return (
    <LinkModalBox>
      <form onSubmit={handleSubmit}>
        <Input
          type="text"
          name="link"
          placeholder="링크 주소를 입력해주세요."
          value={linkText}
          onChange={(e) => setLinkText(e.target.value)}
        />

        <BtnBox>
          <Btn type="submit" title="확인" color="primary" />
          <Btn type="button" title="취소" color="red" onClick={handleClose} />
        </BtnBox>
      </form>
    </LinkModalBox>
  );
}

const LinkModalBox = styled.div`
  ${flexCenterCenter};
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100vw;
  height: 80vh;

  form {
    background-color: #fff;
    padding: 1.5rem;
    border: 2px solid #333;
    border-radius: 8px;
  }
`;

const BtnBox = styled.div`
  ${flexCenterCenter};
  gap: 0.5rem;
`;